import { WSEmptyState } from "@wingspanhq/fe-component-library";
import { ApiKey } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { queriesApiKeys } from "@query";
import { TableApiKeys } from "./TableApiKeys";

type Props = {
  onEdit: (apiKey: ApiKey) => void;
  onRotate: (apiKey: ApiKey) => void;
  onDelete: (apiKey: ApiKey) => void;
  onGenerate: () => void;
};

export const FilterableTableApiKeys: React.FC<Props> = props => {
  const queryApiKeys = queriesApiKeys.listApiKeys.useQueryAll();
  const apiKeys = queryApiKeys.flatData ?? [];

  if (queryApiKeys.isLoading) {
    return <TableApiKeys loading items={[]} {...props} />;
  }

  if (queryApiKeys.isError) {
    return (
      <WSEmptyState
        type="error"
        title="Couldn't load API keys"
        description="Something went wrong loading your API keys. Please try again."
        orientation="horizontal"
        actions={{
          buttons: [
            { label: "Try again", onClick: () => queryApiKeys.refetch() }
          ]
        }}
      />
    );
  }

  if (apiKeys.length === 0) {
    return (
      <WSEmptyState
        type="documents"
        title="No API keys yet"
        description="Generate an API key to authenticate requests to the Wingspan API."
        orientation="horizontal"
        actions={{
          buttons: [{ label: "Generate new key", onClick: props.onGenerate }]
        }}
      />
    );
  }

  return <TableApiKeys items={apiKeys} {...props} />;
};
